import requests from "./http";

class FeatureProdService {
  getItems(id, payload) {
    // console.log("id & payload: ",id, payload);
    return requests.post(`/similar-prods/${id}`,payload);
  }
}

export default new FeatureProdService();